<div id="teammembers">
  <div class="intro-title">Type Table</div>
  <div class="intro-copy" [innerHtml]="introduction | safeHtml"></div>

  <div class="row">
    <div class="col-lg-5 col-md-12">
      <app-team-member-list></app-team-member-list>
    </div>
    <div class="col-lg-7 col-md-12">
      <app-type-table></app-type-table>
    </div>
  </div>
</div>
